import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { MantineProvider } from '@/providers/MantineProvider';
import { QueryProvider } from '@/providers/QueryProvider';

// Import Mantine styles
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-datatable/styles.layer.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <MantineProvider>
        <App />
      </MantineProvider>
    </QueryProvider>
  </StrictMode>
);
